var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('TopNav'),_c('div',{staticClass:"page-content"},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('CustomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }